import React from "react"
import FoxVid from "../images/FoxVid.MP4"

export default function Home() {
    return (
        <div>
            <h1>Home</h1>
            <div className="Video">
                <video src={FoxVid} autoPlay loop muted />
            </div>
        </div>
    )
}